import { trackSignupEvent, type SignupAnalyticsContext } from "./signup";

/** Legacy analytics event names kept for dashboard continuity. */
export type OnboardingFormChatAnalyticsEvent =
  | "onboarding_form_chat_started"
  | "onboarding_form_chat_field_collected"
  | "onboarding_form_chat_completed"
  | "onboarding_form_chat_submitted"
  | "onboarding_form_chat_error";

/** Preferred Chat Bot analytics event names. */
export type OnboardingChatBotAnalyticsEvent =
  | "onboarding_chat_bot_started"
  | "onboarding_chat_bot_field_collected"
  | "onboarding_chat_bot_completed"
  | "onboarding_chat_bot_submitted"
  | "onboarding_chat_bot_error";

const LEGACY_EVENT_MAP: Record<
  OnboardingChatBotAnalyticsEvent,
  OnboardingFormChatAnalyticsEvent
> = {
  onboarding_chat_bot_started: "onboarding_form_chat_started",
  onboarding_chat_bot_field_collected: "onboarding_form_chat_field_collected",
  onboarding_chat_bot_completed: "onboarding_form_chat_completed",
  onboarding_chat_bot_submitted: "onboarding_form_chat_submitted",
  onboarding_chat_bot_error: "onboarding_form_chat_error",
};

export const trackOnboardingChatBotEvent = (
  event: OnboardingChatBotAnalyticsEvent,
  context: SignupAnalyticsContext,
  properties?: Record<string, unknown>,
) => {
  trackSignupEvent(event, context, properties);
  trackSignupEvent(LEGACY_EVENT_MAP[event], context, properties);
};

/** @deprecated Use trackOnboardingChatBotEvent for new instrumentation. */
export const trackOnboardingFormChatEvent = (
  event: OnboardingFormChatAnalyticsEvent,
  context: SignupAnalyticsContext,
  properties?: Record<string, unknown>,
) => {
  trackSignupEvent(event, context, properties);
};
